export enum Currency {
  ETH = 'ETH',
  TWD = 'TWD',
  USD = 'USD',
  USDC = 'USDC',
}
